import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark} from "@/shared/Constants";


export const ContentSlider = styled.div`
  .slider-latest {} 
  .slide-container{
    display: inline-flex;
  }
  .slide-preview-next,
  .slide-item{
    display: inline-flex;
    &:before{
      content:"";
      background: linear-gradient(to left, #ffffff, rgba(255, 255, 255, 0));
      left: 85%;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      position: absolute;
      height: 100%;
      width: 100%;
      bottom:0;
      z-index:1;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color: ${ColorDark.textLight};
        background: linear-gradient(to left, #212121, rgba(255, 255, 255, 0));
        }
      }
    }
    .card{
      display: flex;
      flex-direction: row;
      width: 300px;
      column-gap: 0.5rem;
      position: relative;
      margin-left: 15px;
      height: 90px;
      a{
        position: absolute;
        height: 90px;
      }
      picture{
        position: relative;
        svg {
          width: 12px;
          height: 12px;
          background: #fff;
          border-radius: 50px;
          position: absolute;
          left: 0.5rem;
          top: 0.5rem;
        }
        img{
          width: 90px;
          height: 90px;
      
        }
      }
    }
  }
  .slide-group-control{
    ${breakpoints.mobileFirst}{
      .slide-arrow-left,
      .slide-arrow-right {
        position: absolute; 
        background: ${Color.greyF5F5F5};
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        bottom: 40%;
        z-index: 3;
        &:before{
          content: "";
          background: url("/img/chevron-right.svg") no-repeat;
          height: 15px;
          width: 15px;
          background-size: contain;
          display: flex;
        }
      }
      .slide-arrow-left{
        left: 4rem;
        padding-right: 0.3rem;
        &:before{
          transform: rotateY(180deg);
        }
      }
      .slide-arrow-right{
        right: 0;
        padding-left: 0.3rem;
      }
    }
  }
`;

export const HorizontalSlider = styled.section`
  display: inline-flex;
  position: relative;
  overflow-x: hidden;
  border-bottom: 1px solid ${Color.greySeparator};
  width:100%;
  padding:12px 0;
  ${breakpoints.darkMode} {

    [data-theme='dark'] & {
      border-bottom:1px solid ${ColorDark.greySeparator};
    }
  }
  ${breakpoints.phone} {
    width: 100%;
  }
  p {
    ${Font.sansSemiBold};
    font-size: 15px;
    color: ${Color.black};
    line-height: 18px;
    max-width: 198px;
    ${breakpoints.darkMode} {

      [data-theme='dark'] & {
        color: ${ColorDark.textLight};
      }
    }
    ${breakpoints.phone} {
      line-height: 19px;
    }
    &.title-slider{
      display: flex;
      align-items: center;
      padding-right: 2rem;
      margin-right: 1rem;
      line-height: 20px;
      letter-spacing: -0.15px;
      height: 90px;
      border-right: 1px solid ${Color.tertiaryColor};
      ${breakpoints.darkMode} {

        [data-theme='dark'] & {
          border-right:1px solid ${ColorDark.greySeparator};
        }
      }
    }
  }
`;